import { MenuConfig } from '@anadolu-commons/tohum-ui';
import { TranslocoService } from "@ngneat/transloco";

export const ALL_MENU_ITEMS = [
  {
    name: 'menu.anasayfa',
    slug: 'aday/anasayfa',
    iconClass: 'fa fa-home'
  },
  {
    name: 'menu.profil',
    slug: 'aday/profil/nufus',
    iconClass: 'far fa-user',
  },
  {
    name: 'menu.basvuru',
    slug: 'aday/kesin-kayit-basvuru',
    iconClass: 'far fa-user-check',
    children: [
      {
        name: 'menu.basvuruYap',
        slug: '',
        iconClass: 'far fa-check',
      },
      {
        name: 'menu.basvurularim',
        slug: 'listele',
        iconClass: 'far fa-list',
      },
    ]
  },
  {
    name: 'menu.secmeSinaviBasvuru',
    slug: 'aday/secme-sinavi-basvuru',
    iconClass: 'far fa-spell-check',
    children: [
      {
        name: 'menu.secmeSinaviBasvuruYap',
        slug: '',
        iconClass: 'far fa-check',
      },
      {
        name: 'menu.secmeSinaviBasvurularim',
        slug: 'listele',
        iconClass: 'far fa-list',
      },
      {
        name: 'menu.secmeSinaviGirisBilgilerim',
        slug: 'sinav-giris',
        iconClass: 'far fa-file-alt',
      },
      {
        name: 'menu.secmeSinaviSonuclarim',
        slug: 'sinav-sonuc',
        iconClass: 'far fa-file-alt',
      }
    ]
  },
  {
    name: 'menu.turkDiliVeKulturuBasvurusu',
    slug: 'aday/turk-dili-ve-kulturu-basvurusu',
    iconClass: 'fal fa-comments-alt',
    permissions: ['TurkDiliKulturuBasvurusu'],
    children: [
      {
        name: 'menu.turkDiliVeKulturuBasvuruYap',
        slug: '',
        iconClass: 'far fa-check',
      },
      {
        name: 'menu.turkDiliVeKulturuBasvurularim',
        slug: 'listele',
        iconClass: 'far fa-list',
      },
    ]
  },
  // {
  //   name: 'menu.afBasvuru',
  //   slug: 'aday/af-basvuru',
  //   iconClass: 'far fa-school',
  //   children: [
  //     {
  //       name: 'menu.afBasvuruYap',
  //       slug: '',
  //       iconClass: 'far fa-check',
  //     },
  //     {
  //       name: 'menu.afBasvurularim',
  //       slug: 'listele',
  //       iconClass: 'far fa-list',
  //     },
  //   ]
  // },
  /*{
    name: 'menu.tcNoDegisiklikBasvuru',
    slug: 'aday/tc-no-degisiklik-basvuru',
    iconClass: 'far fa-retweet',
    children: [
      {
        name: 'menu.tcNoDegisiklikBasvuruYap',
        slug: '',
        iconClass: 'far fa-check',
      },
      {
        name: 'menu.tcNoDegisiklikBasvurularim',
        slug: 'listele',
        iconClass: 'far fa-list',
      },
    ]
  },*/
  {
    name: 'menu.cezaInfazKurumuOgretmenBasvurusu',
    slug: 'aday/ceza-infaz-kurumu-ogretmen-basvurusu',
    iconClass: 'far fa-home',
  },
  /*{
    name: 'menu.belgeler',
    slug: 'aday/belgeler',
    iconClass: 'far fa-file-alt',
  },*/
  {
    name: 'menu.kilavuzlar',
    slug: 'kilavuzlar',
    iconClass: 'far fa-books',
  },
];

export const menuConfig: MenuConfig = {
  list: ALL_MENU_ITEMS
};
